export default {
    methods: {
        handleKeyPress(event) {
            if (event.ctrlKey && event.key === 'F1') {
                localStorage.removeItem('apiResponse');
                localStorage.removeItem('apiResponse_FACE_ID');
                localStorage.removeItem('images');
                alert('Limpeza de localStorage conclída.');
                window.location.reload();
            }
        }
    }
}